function normalizeKey(value = "") {
  return String(value).toLowerCase().replace(/[^a-z0-9]+/g, "");
}

function namesMatch(a, b) {
  if (!a || !b) return false;
  const left = normalizeKey(a);
  const right = normalizeKey(b);
  if (!left || !right) return false;
  return left === right || left.includes(right) || right.includes(left);
}

/** API messages that mean “no rows”, not a hard failure. */
export function isBenignEmptyContentMessage(message) {
  const text = String(message || "").toLowerCase().trim();
  if (!text) return true;
  return (
    text.includes("not found") ||
    text.includes("no article") ||
    text.includes("no media") ||
    text.includes("no content") ||
    text.includes("no record") ||
    text.includes("empty") ||
    text.includes("nothing to show")
  );
}

export function rowMatchesTopicSubCategory(row, topicIds) {
  if (!topicIds?.subCategoryName) return true;
  const subName =
    row?.sub_category?.name ||
    row?.sub_category_name ||
    row?.subCategory?.name ||
    row?.subCategoryName ||
    "";
  if (!String(subName).trim()) return true;
  return namesMatch(subName, topicIds.subCategoryName);
}

export function rowMatchesTopicCategory(row, topicIds) {
  if (!topicIds?.categoryName) return true;
  const catName =
    row?.category?.name || row?.category_name || row?.categoryName || "";
  if (!String(catName).trim()) return true;
  return namesMatch(catName, topicIds.categoryName);
}

export function rowMatchesTopic(row, topicIds) {
  return rowMatchesTopicCategory(row, topicIds) && rowMatchesTopicSubCategory(row, topicIds);
}

export function filterRowsForTopic(rows, topicIds) {
  if (!Array.isArray(rows) || !topicIds) return rows || [];
  return rows.filter((row) => rowMatchesTopic(row, topicIds));
}
